module.exports = __webpack_public_path__ + "static/media/GBR Processing final home page infographic - Desktop - GBR Processing - 15-07-2024 N.b9c184a5.gif";